module.exports = __webpack_public_path__ + "static/media/usn-1b.276c89f6.jpg";